import Tasks from '../pages/tasks'

export default [
  {
    path: '/',
    redirectTo: '/tasks',
  },
  {
    path: '/tasks',
    component: Tasks,
  },
]
